module.exports = __webpack_public_path__ + "static/media/Masary_Wordmark_Horizontal_White.7516b9ff.png";